import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { monthCloseOutAlertConstants } from '../../actions/constant';
import monthlyCloseoutService from 'src/services/apiServices/monthlyCloseOut/monthlyCloseoutService';

const {
  REOPEN_CLOSEOUT_REQUEST,
  REOPEN_CLOSEOUT_SUCCESS,
  REOPEN_CLOSEOUT_FAILURE,
  REOPEN_CLOSEOUT_LOADING,
} = monthCloseOutAlertConstants;
function* reopenCloseout(action: any): SagaReturnType<any> {
  try {
    yield put({ type: REOPEN_CLOSEOUT_LOADING });
    const response = yield call(monthlyCloseoutService.reopenCloseout, action.payload);

    if (response?.status === 200) {
      yield put({ type: REOPEN_CLOSEOUT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      (typeof error === 'object' && error?.message) ||
      'Failed to reopen closeout.';
    yield put({ type: REOPEN_CLOSEOUT_FAILURE, payload: { message } });
  }
}

function* reopenCloseoutSaga() {
  yield takeEvery(REOPEN_CLOSEOUT_REQUEST, reopenCloseout);
}

export default reopenCloseoutSaga;
